import { jsx, css } from '@emotion/react';

import { Contacts } from '../OC/oc-contacts';

const styles = css``;

export const TalkToAnExpert = ({ list, heading, body, anchor, className }) => (
  <section css={styles} className={className}>
    <h2 id={anchor}>{heading}</h2>
    <p>{body}</p>
    <Contacts list={list} />
  </section>
);
